import PubSub from 'PubSub';

const eventBus = new PubSub()

export default eventBus;